import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {trackEventByUrl} from "../helpers/events";
import InlineModalVideoPortal from "./InlineModalVideoPortal";

class InlineModalVideo extends Component {
    static propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        videoId: PropTypes.object.isRequired,
        videoUrl: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        className: PropTypes.string
    };

    static defaultProps = {
        className: 'button button--primary'
    };

    state = {
        modalIsOpen: false
    };

    handleClick = (e, videoUrl, title) => {
        e.preventDefault();
        trackEventByUrl(videoUrl, title);
        this.setState({modalIsOpen: true});
    };

    handleClose = () => {
        this.setState({modalIsOpen: false});
    };

    render() {
        const {videoId, videoUrl, title, className} = this.props;

        return (
            <React.Fragment>
                <InlineModalVideoPortal videoId={videoId} videoUrl={videoUrl} handleClose={this.handleClose} isOpen={this.state.modalIsOpen}/>
                <button className={`inlineModalButton ${className}`} onClick={(e) => this.handleClick(e, videoUrl, title)}>
                    {title}
                </button>
            </React.Fragment>
        )
    }
}

export default InlineModalVideo;



// WEBPACK FOOTER //
// ./frontend/components/InlineModalVideo.jsx